export const REDIRECT_DEFAULT = '/calendar';